/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PriceTable from "./PriceTable";

const PriceTableContainer = () => {
  return (
    <PriceTable />
  );
};

export default PriceTableContainer;
